import React, { Component } from "react"
import { connect } from "react-redux"
import { compose } from "recompose"
import { withStyles } from "@material-ui/core/styles"
import styles from "./styles"
import Dialog from "@material-ui/core/Dialog"
import DialogTitle from "@material-ui/core/DialogTitle"
import Popover from "@material-ui/core/Popover"
import Tooltip from "@material-ui/core/Tooltip"
import DialogContent from "@material-ui/core/DialogContent"
import withMobileDialog from "@material-ui/core/withMobileDialog"
import Select from "@material-ui/core/Select"
import MenuItem from "@material-ui/core/MenuItem"
import Image from "../../assets/images/login_bg.jpg"
import Button from "@material-ui/core/Button"
import Paper from "@material-ui/core/Paper"
import classNames from "classnames"
import { withRouter } from "react-router"
import {
  createShoot,
  createCalendars,
  createMasterCalendar,
  toggleEditShootDialog,
  setEditShoot,
  updateShoot,
} from "../../actions/shoots"
import { pushCrew } from "../../actions/crew"

import { getUserBookingHistory } from "../../actions/users"

import { isEmpty, pickBy, head, filter } from "lodash"
import Grid from "@material-ui/core/Grid"
import { openSnackBar } from "../../actions/snack-bar"
import Typography from "@material-ui/core/Typography"
import CircularProgress from "@material-ui/core/CircularProgress"
import Box from "@material-ui/core/Box"
import moment from "moment"
import EditOutlinedIcon from "@material-ui/icons/EditOutlined"
import FileCopyOutlinedIcon from "@material-ui/icons/FileCopyOutlined"
import CloseIcon from "@material-ui/icons/Close"
import { convertToAbbr } from "../../lib/states.js"
import Avatar from "@material-ui/core/Avatar"
import Card from "@material-ui/core/Card"
import CardContent from "@material-ui/core/CardContent"

import Switch from "@material-ui/core/Switch"
import Divider from "@material-ui/core/Divider"
import { MuiThemeProvider } from "@material-ui/core/styles"
import {
  ExpansionPanel,
  ExpansionPanelSummary,
  ExpansionPanelDetails,
} from "@material-ui/core"
import ExpandMoreIcon from "@material-ui/icons/ExpandMore"
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers"

import { pickersTheme } from "../../themes/main"
import DateFnsUtils from "@date-io/date-fns"

import { getCurrentHost } from "../../utils/getHost"

export const filterOptions = [
  // {
  //   id: 1,
  //   type: "status",
  //   name: "Standby",
  //   description: "Shoots that are on standby",
  //   func: shoot => {
  //     return !shoot.firm && shoot.status !== "cancelled"
  //   },
  // },
  // {
  //   id: 2,
  //   type: "status",
  //   name: "Firm",
  //   description: "Shoots that are firm",
  //   func: shoot => {
  //     return shoot.firm && shoot.status !== "cancelled"
  //   },
  // },
  {
    id: 3,
    type: "standard",
    name: "Wrapped",
    description: "Shoots that are wrapped",
    func: shoot => {
      return shoot.status === "wrapped" && shoot.status !== "cancelled"
    },
  },
  {
    id: 4,
    type: "standard",
    name: "Open",
    description: "Not all crew are firm",
    func: shoot => {
      return (
        shoot.roles.filter(y => !y.user_id).length > 0 &&
        shoot.status === "open" &&
        shoot.status !== "cancelled"
      )
    },
  },
  {
    id: 5,
    type: "standard",
    name: "Booked",
    description: "All crew are firm",
    func: shoot => {
      return shoot.status === "booked" && shoot.status !== "cancelled"
    },
  },
  {
    id: 7,
    type: "standard",
    name: "Cancelled",
    description: "Shoots marked as cancelled",
    func: shoot => {
      return shoot.status === "cancelled"
    },
  },
  {
    id: 8,
    type: "standard",
    name: "Billed",
    description: "Shoots that are billed",
    func: shoot => {
      return shoot.status === "billed" && shoot.status !== "cancelled"
    },
  },
  {
    id: 9,
    type: "standard",
    name: "Paid",
    description: "Shoots that are paid",
    func: shoot => {
      return shoot.status === "paid" && shoot.status !== "cancelled"
    },
  },
]

class EditShootDialog extends Component {
  constructor(props) {
    super(props)

    this.state = {
      switch: false,
      working: false,
      newNote: "",
      savingProfile: false,
      selectedCountry: "US",
      selectedCompany: "",
      isFormOk: false,
      changedStatus: null,
      confirmDuplicate: false,
      userBookingHistory: null,
      popover: {
        anchor: null,
        func: () => "",
      },
      start_date: new Date(),
      end_date: new Date(),
    }
  }

  async componentDidMount() {
    const { shoot } = this.props
    // const { result } = this.props
    const userIds = shoot.users.map(x => x.user_id)
    const creator_id = shoot.creator_id

    if (getCurrentHost() !== "crewmama") {
      let bookingHistory = await this.props.dispatch(
        getUserBookingHistory({ userIds: userIds, creator_id: creator_id })
      )

      if (bookingHistory && !isEmpty(bookingHistory.bookings)) {
        bookingHistory.bookings.forEach(booking => {
          booking.location = this.parseJson(booking.location)
        })

        this.setState({
          userBookingHistory: bookingHistory.bookings,
        })
      }
    }
  }

  parseJson = data => {
    let location = null
    try {
      location = data ? JSON.parse(data) : null
    } catch (e) {
      console.log(e)
    }
    return location
  }

  handleClose = () => {
    this.setState({
      switch: false,
      start_date: new Date(),
      end_date: new Date(),
      userBookingHistory: null,
    })
    this.props.dispatch(toggleEditShootDialog(false))
    this.props.dispatch(pushCrew({}))
    this.props.dispatch(setEditShoot(true))
  }

  handleChangeShootStatus = event => {
    this.setState({ working: true })
    const { shoot } = this.props
    let newShoot = { ...shoot }
    newShoot.status = event.target.value
    newShoot.location = JSON.stringify(newShoot.location)

    this.props
      .dispatch(updateShoot(newShoot.id, { ...newShoot }))
      .then(e => {
        this.props.onUpdateShootStatus(e.id)
        this.props.dispatch(
          openSnackBar({ message: "Shoot Status is Updated" })
        )
        this.setState({ working: false, changedStatus: event.target.value })
      })
      .catch(error => {
        this.props.dispatch(
          openSnackBar({
            message: "Something is wrong, shoot status is not update",
          })
        )
        this.setState({ working: false })
      })
  }

  duplicate = () => {
    let shootId
    this.setState({ working: true })
    const shoot = this.props.shoot
    this.setState({ anchorEl: null })
    const newShoot = {
      ...shoot,
      name: "Copy of " + shoot.name,
      start_date: this.state.start_date,
      end_date: this.state.end_date,
      call_time: shoot.call_time,
      full_day: shoot.day === "full" ? 1 : 0,
      location: JSON.stringify(shoot.location),
      firm: shoot.firm,
    }
    if (shoot.roles && shoot.roles.length > 0) {
      newShoot.glueData = {
        roles: shoot.roles.map(x => {
          return {
            role_id: x.role_id,
            client_rate: Number(x.client_rate),
            crew_rate: Number(x.crew_rate),
            user_id: x.user_id,
          }
        }),
      }
    }

    if (shoot.equipment.length > 0) {
      if (newShoot.glueData) {
        newShoot.glueData.equipment = shoot.equipment.map(x => {
          return {
            equipment_id: x.equipment_id,
          }
        })
      } else {
        newShoot.glueData = {
          equipment: shoot.equipment.map(x => {
            return {
              equipment_id: x.equipment_id,
            }
          }),
        }
      }
    }
    this.props
      .dispatch(createShoot(newShoot))
      .then(res => {
        shootId = res.shoots[0].id
        return Promise.all([
          this.props.dispatch(createCalendars(shootId)),
          this.props.dispatch(createMasterCalendar(shootId)),
        ])
      })
      .then(r => {
        this.props.dispatch(
          openSnackBar({
            message: `${newShoot.name} is created and ${r.message}`,
          })
        )
        this.goToShootDetails(shootId)
        this.setState({ working: false })
        // window.location.href = "/shoots/" + res.shoots[0].id
      })
      .catch(error => {
        this.props.dispatch(
          openSnackBar({
            message: "Something is wrong, shoot cannot be duplicated",
          })
        )
        this.setState({ working: false })
      })
  }

  goToShootDetails = async shootId => {
    if (getCurrentHost() === "crewmama") {
      const { users, shoot, authenticatedUser, activeCompany } = this.props
      let creator = null
      if (users.length > 1) {
        creator = users.find(x => Number(x.id) === Number(shoot.creator_id))
      }
      if (
        (creator && authenticatedUser && creator.id === authenticatedUser.id) ||
        activeCompany
      ) {
        await this.props.onClickEdit(shootId)
      } else {
        window.location.href = "/my-shoots/" + shootId + "/details"
        await this.props.dispatch(setEditShoot())
      }
    } else {
      await this.props.onClickEdit(shootId)
    }

    await this.props.dispatch(setEditShoot())
  }

  setPopover = (e, func) => {
    this.setState({
      popover: {
        anchor: e.currentTarget,
        func: {
          $set: func,
        },
      },
    })
  }

  handleDateChange = (date, key) => {
    if (typeof key === "object") {
      if (this.state.switch) {
        let nextDay = moment(date)
          .add(1, "days")
          .toDate()
        this.setState({
          [key[0]]: date,
          [key[1]]: new Date(new Date(nextDay).toGMTString()),
        })
      } else {
        this.setState({
          [key[0]]: date,
          [key[1]]: date,
        })
      }
    } else {
      this.setState({
        [key]: date,
      })
    }
  }

  render() {
    const { fullScreen, classes, shoot, shootCrew, activeCompany } = this.props
    const { working, popover, userBookingHistory } = this.state
    let openPositions = []
    // console.log("shootCrew", shootCrew)
    // console.log("shoot", shoot)
    openPositions =
      !isEmpty(shoot.roles) &&
      shoot.roles.filter(role => {
        return !role.user_id
      })

    return (
      <Dialog
        className={classes.profileDialog}
        fullScreen={fullScreen}
        open={this.props.editShootDialogOpen}
        onClose={this.handleClose} // onEntered={this.setUpForm} // disableBackdropClick={false}
        // onExited={this.clearState}
        aria-labelledby="responsive-dialog-title"
        PaperProps={{ classes: { root: classes.dialogPaper } }}
      >
        <form id="edit-form" noValidate autoComplete="off">
          <DialogTitle disableTypography className={classes.dialogTitle}>
            {!isEmpty(shoot) && (
              <Typography variant="h6" className={classes.dialogTitleText}>
                {shoot.name}
              </Typography>
            )}

            <div style={{ alignSelf: "flex-end", display: "flex" }}>
              <EditOutlinedIcon
                className={classes.editIcon}
                onClick={() => this.goToShootDetails(shoot.id)}
                aria-label="Close"
              />

              <Tooltip placement="top" title="Duplicate Shoot">
                <FileCopyOutlinedIcon
                  className={classes.duplicateIcon}
                  onClick={e =>
                    this.setPopover(e, bool => (bool ? this.duplicate() : ""))
                  }
                  aria-label="Close"
                />
              </Tooltip>
              <Popover
                id={"areYouSure"}
                open={Boolean(popover.anchor)}
                anchorEl={popover.anchor}
                onClose={e => {
                  // popover.func(false)
                  this.setState({
                    popover: {
                      anchor: null,
                      func: () => "",
                    },
                    start_date: new Date(),
                    end_date: new Date(),
                  })
                }}
                anchorOrigin={{ vertical: "top", horizontal: "center" }}
                transformOrigin={{ vertical: "bottom", horizontal: "center" }}
              >
                <div style={{ textAlign: "center" }}>
                  {/* <Typography style={{ margin: "8px" }}>
                    Are You Sure?
                  </Typography> */}
                  <Box>
                    <Typography
                      variant="h6"
                      className={classes.duplicateShootTitle}
                    >
                      Duplicate {shoot.name}
                    </Typography>
                  </Box>

                  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    {!this.state.switch ? (
                      <Card className={classes.picker}>
                        <CardContent style={{ display: "flex" }}>
                          <MuiThemeProvider theme={pickersTheme}>
                            <KeyboardDatePicker
                              label="Date"
                              autoOk
                              disablePast
                              value={this.state.start_date}
                              onChange={e => {
                                this.handleDateChange(e, [
                                  "start_date",
                                  "end_date",
                                ])
                              }}
                              variant="inline"
                              inputVariant="outlined"
                              format="MM/dd/yyyy"
                            />
                          </MuiThemeProvider>
                        </CardContent>
                      </Card>
                    ) : (
                      <Card className={classes.picker}>
                        <CardContent style={{ display: "flex" }}>
                          <MuiThemeProvider theme={pickersTheme}>
                            <span
                              style={{
                                marginRight: "10px",
                                marginLeft: "10px",
                              }}
                            >
                              <KeyboardDatePicker
                                disablePast
                                autoOk
                                variant="inline"
                                inputVariant="outlined"
                                label="Start Date"
                                format="MM/dd/yyyy"
                                value={this.state.start_date}
                                InputAdornmentProps={{ position: "start" }}
                                onChange={e => {
                                  this.handleDateChange(e, [
                                    "start_date",
                                    "end_date",
                                  ])
                                }}
                                minDateMessage={`Start date should not be in the past`}
                              />
                            </span>
                            <span>
                              <KeyboardDatePicker
                                minDate={new Date()}
                                autoOk
                                variant="inline"
                                inputVariant="outlined"
                                label="End Date"
                                format="MM/dd/yyyy"
                                value={this.state.end_date}
                                InputAdornmentProps={{ position: "start" }}
                                onChange={e =>
                                  this.handleDateChange(e, "end_date")
                                }
                                minDateMessage={`End date should not be before the start date`}
                              />
                            </span>
                          </MuiThemeProvider>
                        </CardContent>
                      </Card>
                    )}
                  </MuiPickersUtilsProvider>

                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-evenly",
                      marginBottom: 20,
                    }}
                  >
                    <Typography
                      className={classNames("", {
                        [classes.selectedDay]: !this.state.switch,
                        [classes.unselectedDay]: this.state.switch,
                      })}
                    >
                      Single Day
                    </Typography>
                    <Switch
                      checked={this.state.switch}
                      onChange={e => {
                        // change back to single day shoot
                        if (this.state.switch) {
                          this.setState({ end_date: this.state.start_date })
                        } else {
                          this.setState({
                            end_date: moment(this.state.start_date)
                              .add(1, "days")
                              .toDate(),
                          })
                        }
                        this.setState({ switch: !this.state.switch })
                      }}
                    />
                    <Typography
                      className={classNames("", {
                        [classes.selectedDay]: this.state.switch,
                        [classes.unselectedDay]: !this.state.switch,
                      })}
                    >
                      Multi Day
                    </Typography>
                  </div>

                  <div style={{ display: "flex", justifyContent: "flex-end" }}>
                    <Button
                      onClick={e => {
                        this.setState({ popover: { anchor: null } })
                      }}
                    >
                      No
                    </Button>
                    <Button
                      onClick={e => {
                        this.duplicate()
                        this.setState({
                          popover: {
                            anchor: null,
                            func: () => "",
                          },
                        })
                      }}
                      color="primary"
                    >
                      Yes
                    </Button>
                  </div>
                </div>
              </Popover>
              {fullScreen && (
                <CloseIcon
                  onClick={this.handleClose}
                  className={classes.duplicateIcon}
                  aria-label="Close"
                />
              )}
            </div>
          </DialogTitle>
          {!isEmpty(shoot) && (
            <DialogContent>
              {working && working === true ? (
                <CircularProgress style={{ margin: "200px" }} />
              ) : (
                <div>
                  <Grid container spacing={1} className={classes.alignClass}>
                    <Grid item xs={6} sm={4} md={2}>
                      <Typography
                        component="p"
                        className={classes.noteLineText}
                      >
                        Date
                      </Typography>
                      <Typography variant="h5" className={classes.headline}>
                        {moment(shoot.end_date).format("ddd MMM D, YYYY")}
                      </Typography>
                    </Grid>
                    <Grid item xs={6} sm={4} md={2}>
                      <Typography
                        component="p"
                        className={classes.noteLineText}
                      >
                        Time
                      </Typography>
                      <Typography variant="h5" className={classes.headline}>
                        {shoot.timezone}
                      </Typography>
                    </Grid>
                    <Grid item xs={6} sm={4} md={2}>
                      <Typography
                        component="p"
                        className={classes.noteLineText}
                      >
                        Location
                      </Typography>
                      {shoot.location &&
                        shoot.location.city && (
                          <Typography variant="h5" className={classes.headline}>
                            {`${shoot.location.city},
                        ${head(convertToAbbr(shoot.location.state)) &&
                          head(convertToAbbr(shoot.location.state)).abbr}`}
                          </Typography>
                        )}
                    </Grid>
                    <Grid item xs={6} sm={4} md={2}>
                      <Typography
                        component="p"
                        className={classes.noteLineText}
                      >
                        Status
                      </Typography>
                      <Typography variant="h5" className={classes.headline}>
                        {shoot.firm === 0 ? "Standby" : "Firm"}
                      </Typography>
                    </Grid>
                    {/* <Grid item xs={6} sm={4} md={2}>
                      <Typography
                        component="p"
                        className={classes.noteLineText}
                      >
                        Status
                      </Typography>
                      <Typography variant="h5" className={classes.headline}>
                        {shoot.status}
                      </Typography>
                    </Grid> */}
                    {activeCompany && (
                      <Grid
                        item
                        xs={12}
                        sm={12}
                        md={2}
                        className={classes.statusWrap}
                      >
                        {!isEmpty(shoot) && (
                          <Select
                            value={shoot.status}
                            onChange={event =>
                              this.handleChangeShootStatus(event)
                            }
                            displayEmpty
                            className={
                              (classes.selectEmpty, classes.backgroundGreen)
                            }
                            inputProps={{ "aria-label": "Without label" }}
                          >
                            {filterOptions.map((opt, index) => (
                              <MenuItem
                                value={opt.name.toLowerCase()}
                                key={`index+${index + 1}`}
                              >
                                {opt.name}
                              </MenuItem>
                            ))}
                          </Select>
                        )}
                      </Grid>
                    )}
                  </Grid>
                  {!isEmpty(shoot.users) && (
                    <Grid container className={classes.alignClass}>
                      <Grid item xs={6} sm={12}>
                        <Typography
                          component="p"
                          className={classes.noteLineText}
                        >
                          Crew Members ({shoot.users.length})
                        </Typography>
                      </Grid>
                    </Grid>
                  )}

                  <Grid container>
                    {!isEmpty(shoot.users) &&
                      shoot.users.map((user, crewIndex) => {
                        if (user.user_id) {
                          let crew = shoot.roles.find(
                            c => c.user_id === user.user_id
                          )
                          return (
                            crew && (
                              <Grid
                                key={`crew-${crewIndex + 1}`}
                                item
                                xs={6}
                                sm={6}
                                md={4}
                                className={classes.padding}
                              >
                                <ExpansionPanel>
                                  <ExpansionPanelSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls="panel1a-content"
                                    id="panel1a-header"
                                    className={classes.backgroundLight}
                                  >
                                    <Box>
                                      <Avatar
                                        className={[
                                          classes.purple,
                                          classes.positionAbsolute,
                                          classes.large,
                                        ]}
                                        src={
                                          !isEmpty(user.profile_image)
                                            ? `https://res.cloudinary.com/adesk/image/upload/c_thumb,g_face:auto,z_0.7,h_170,w_300,fl_lossy,f_auto/v${
                                                JSON.parse(user.profile_image)
                                                  .version
                                              }/${
                                                JSON.parse(user.profile_image)
                                                  .public_id
                                              }.${
                                                JSON.parse(user.profile_image)
                                                  .format
                                              }`
                                            : Image
                                        }
                                      >
                                        OP
                                      </Avatar>
                                      <Typography
                                        component="p"
                                        className={[
                                          classes.noteLineTextCrew,
                                          classes.marginLeft,
                                        ]}
                                      >
                                        {user.first_name} {user.last_name}
                                      </Typography>

                                      <Typography
                                        component="p"
                                        className={[
                                          classes.noteLineTextCrew,
                                          classes.marginLeft,
                                          classes.textBold,
                                        ]}
                                      >
                                        {crew.name}
                                      </Typography>
                                    </Box>
                                  </ExpansionPanelSummary>

                                  <ExpansionPanelDetails
                                    className={classes.backgroundLight}
                                  >
                                    {!isEmpty(shoot.roles) &&
                                      !isEmpty(shootCrew) &&
                                      shootCrew.map((role, roleIndex) => {
                                        if (role.id === crew.user_id) {
                                          return (
                                            <Box>
                                              {!isEmpty(role.email) && (
                                                <Typography
                                                  key={`role-${roleIndex + 1}`}
                                                  component="p"
                                                  className={[
                                                    classes.noteLineTextCrew,
                                                    classes.textBold,
                                                    classes.paddingLeft,
                                                  ]}
                                                >
                                                  Email:
                                                  <span
                                                    component="p"
                                                    className={[
                                                      classes.noteLineTextCrew,
                                                    ]}
                                                  >
                                                    {" "}
                                                    {role.email}
                                                  </span>
                                                </Typography>
                                              )}
                                              <Typography
                                                component="p"
                                                className={[
                                                  classes.noteLineTextCrew,
                                                  classes.textBold,
                                                  classes.paddingLeft,
                                                ]}
                                              >
                                                Phone:{" "}
                                                <span
                                                  component="p"
                                                  className={[
                                                    classes.noteLineTextCrew,
                                                  ]}
                                                >
                                                  {" "}
                                                  {role.phone}
                                                </span>
                                              </Typography>
                                              <Divider />

                                              {!isEmpty(userBookingHistory) &&
                                                userBookingHistory
                                                  .filter(
                                                    ub =>
                                                      ub.user_id ===
                                                      crew.user_id
                                                  )
                                                  .map(
                                                    (history, historyIndex) =>
                                                      historyIndex <= 2 && (
                                                        <Typography
                                                          key={`history-${historyIndex +
                                                            1}`}
                                                          component="p"
                                                          className={[
                                                            classes.noteLineTextCrew,
                                                            classes.textBold,
                                                            classes.padding,
                                                          ]}
                                                        >
                                                          Shoot:
                                                          <span
                                                            component="p"
                                                            className={[
                                                              classes.noteLineTextCrew,
                                                            ]}
                                                          >
                                                            {" "}
                                                            {history.name}
                                                          </span>
                                                          <Typography
                                                            component="p"
                                                            className={[
                                                              classes.noteLineTextCrew,
                                                              classes.textBold,
                                                              // classes.padding,
                                                            ]}
                                                          >
                                                            Position:
                                                            <span
                                                              component="p"
                                                              className={[
                                                                classes.noteLineTextCrew,
                                                              ]}
                                                            >
                                                              {" "}
                                                              {history.position}
                                                            </span>
                                                          </Typography>
                                                          <Typography
                                                            component="p"
                                                            className={[
                                                              classes.noteLineTextCrew,
                                                              classes.textBold,
                                                            ]}
                                                          >
                                                            Date:
                                                            <span
                                                              component="p"
                                                              className={[
                                                                classes.noteLineTextCrew,
                                                              ]}
                                                            >
                                                              {" "}
                                                              {moment(
                                                                history.start_date
                                                              ).format(
                                                                "MMM DD, YYYY"
                                                              )}{" "}
                                                            </span>
                                                          </Typography>
                                                          <Typography
                                                            component="p"
                                                            className={[
                                                              classes.noteLineTextCrew,
                                                              classes.textBold,
                                                            ]}
                                                          >
                                                            Location:
                                                            {history.location && (
                                                              <span
                                                                component="p"
                                                                className={[
                                                                  classes.noteLineTextCrew,
                                                                ]}
                                                              >
                                                                {" "}
                                                                {` ${
                                                                  history
                                                                    .location
                                                                    .city
                                                                }, 
                                                   ${head(
                                                     convertToAbbr(
                                                       history.location.state
                                                     )
                                                   ) &&
                                                     head(
                                                       convertToAbbr(
                                                         history.location.state
                                                       )
                                                     ).abbr}`}
                                                              </span>
                                                            )}
                                                          </Typography>
                                                        </Typography>
                                                      )
                                                  )}
                                            </Box>
                                          )
                                        }
                                      })}
                                  </ExpansionPanelDetails>
                                </ExpansionPanel>
                              </Grid>
                            )
                          )
                        }
                      })}
                  </Grid>

                  {!isEmpty(openPositions) && (
                    <Grid container className={classes.alignClass}>
                      <Grid item xs={6} sm={12}>
                        <Typography
                          component="p"
                          className={classes.noteLineText}
                        >
                          Open Positions ({openPositions.length})
                        </Typography>
                      </Grid>
                    </Grid>
                  )}

                  <Grid container>
                    {!isEmpty(openPositions) &&
                      openPositions.map((position, positionIndex) => (
                        <Grid
                          key={`role-${positionIndex + 1}`}
                          item
                          xs={6}
                          sm={6}
                          md={4}
                          className={classes.padding}
                        >
                          <Paper
                            elevation={3}
                            className={classes.positionSlide}
                          >
                            <Typography
                              component="p"
                              className={[
                                classes.noteLineTextCrew,
                                classes.textBold,
                              ]}
                            >
                              {position.name}
                            </Typography>
                            {shoot.shoots &&
                              shoot.shoots.length > 0 &&
                              shoot.shoots.find(
                                s =>
                                  s.role_id === position.role_id &&
                                  s.position_id === position.id
                                    ? true
                                    : false
                              ) && (
                                <Typography
                                  component="p"
                                  className={[classes.noteLineTextCrew]}
                                >
                                  {
                                    filter(
                                      shoot.shoots,
                                      s =>
                                        s.role_id === position.role_id &&
                                        s.position_id === position.id
                                    ).length
                                  }{" "}
                                  {filter(
                                    shoot.shoots,
                                    s =>
                                      s.role_id === position.role_id &&
                                      s.position_id === position.id
                                  ).length > 1
                                    ? "Applicants"
                                    : "Applicant"}
                                </Typography>
                              )}
                          </Paper>
                        </Grid>
                      ))}
                  </Grid>

                  <Grid container className={classes.alignClass}>
                    <Grid item xs={12}>
                      <Typography
                        component="h4"
                        className={classes.detailsHeading}
                      >
                        Shoot Details
                      </Typography>
                    </Grid>
                    <Grid item xs={12}>
                      <Typography
                        component="p"
                        className={(classes.noteLineText, classes.alignLeft)}
                        style={{ whiteSpace: "pre-line" }}
                      >
                        {shoot.forward_facing_text}
                      </Typography>
                    </Grid>
                  </Grid>

                  <Grid container className={classes.alignClass}>
                    <Grid item xs={12}>
                      <Typography
                        component="h4"
                        className={classes.detailsHeading}
                      >
                        Private Notes
                      </Typography>
                    </Grid>
                    <Grid item xs={12}>
                      <Typography
                        component="p"
                        className={(classes.noteLineText, classes.alignLeft)}
                        style={{ whiteSpace: "pre-line" }}
                      >
                        {shoot.creator_text}
                      </Typography>
                    </Grid>
                  </Grid>

                  <Grid container className={classes.alignClass}>
                    <Grid item xs={12}>
                      <Typography
                        component="p"
                        className={(classes.noteLineText, classes.alignLeft)}
                      >
                        {moment(shoot.start_date).format("MMM")}{" "}
                        {moment(shoot.start_date).format("D")}-{moment(
                          shoot.end_date
                        ).format("D")}
                      </Typography>

                      {!isEmpty(shoot.roles) &&
                        !isEmpty(shootCrew) &&
                        shoot.roles.map((role, roleIndex) => {
                          if (role.user_id) {
                            let crew = shootCrew.find(
                              c => c.id === role.user_id
                            )
                            return (
                              crew && (
                                <Typography
                                  component="p"
                                  className={classes.alignLeft}
                                >
                                  {role.name}:{" "}
                                  {crew.first_name + " " + crew.last_name} -{" "}
                                  {crew.email} -({crew.phone})
                                </Typography>
                              )
                            )
                          }
                        })}
                    </Grid>
                  </Grid>
                </div>
              )}
            </DialogContent>
          )}
        </form>
      </Dialog>
    )
  }
}

const mapStateToProps = state => {
  return {
    authenticatedUser: state.authentication.authenticatedUser,
    editShootDialogOpen: state.shoots.editShootDialogOpen,
    confirmDuplicateShootDialogueOpen:
      state.shoots.confirmDuplicateShootDialogueOpen,
    user: state.users.editUser,
    shoot: state.shoots.editShoot,
    shootCrew: state.crew.crew,
    users: state.misc.users,
    activeCompany: state.companies.activeCompany,
  }
}

export default withRouter(
  compose(
    connect(mapStateToProps),
    withStyles(styles, { withTheme: true }),
    withMobileDialog()
  )(EditShootDialog)
)
